import React from 'react';
import ProgressLabel from '../ProgressLabel';

const ParsingLabel = () => (
    <ProgressLabel text="Extracting Info" color="blue" />
);

export default ParsingLabel;
